import PropTypes from 'prop-types'
import {Box, Button, Text, Spacer} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import Attention from './Attention'

const ChangeBankAccountPromptAlert = ({
  supplierName,
  onOpenBankAccountDetails,
}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Attention>
      <Text textStyle="body-intro-medium">
        {t('bankAccountDetails.outsidePayments.title')}
      </Text>
      <Box display="flex" flexDirection={{base: 'column', md: 'row'}}>
        <Text textStyle="body-small">
          {t(
            'bankAccountDetails.outsidePayments.changeBankAccountPrompt.message',
            {
              supplierName,
            },
          )}
        </Text>
        <Spacer />
        <Box mt={{base: 2, md: 0}} ml={{base: 0, md: 2}}>
          <Button
            variant="tertiary"
            borderWidth={1}
            borderColor="mld.neutral.1000"
            data-testid="view-bank-account-details"
            onClick={onOpenBankAccountDetails}
          >
            {t('bankAccountDetails.outsidePayments.button')}
          </Button>
        </Box>
      </Box>
    </Attention>
  )
}

ChangeBankAccountPromptAlert.propTypes = {
  supplierName: PropTypes.string.isRequired,
  onOpenBankAccountDetails: PropTypes.func.isRequired,
}

export default ChangeBankAccountPromptAlert
